import { isProdEnv } from 'root/src/shared/util/envSelect'
import stackConfig from 'root/config/stackConfig'

export const authApiStage = 'v1'
export const authApiId = isProdEnv ? 'zf84oqf45d' : stackConfig.awsAuthApiId || 'qyvi4marn6'
export const authApiDomain = `${authApiId}.execute-api.us-east-1.amazonaws.com/${authApiStage}`
